"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Container_1 = __importDefault(require("@material-ui/core/Container"));
var Container = function (_a) {
    var children = _a.children, _b = _a.disableGutters, disableGutters = _b === void 0 ? false : _b, _c = _a.fixed, fixed = _c === void 0 ? false : _c, _d = _a.maxWidth, maxWidth = _d === void 0 ? 'lg' : _d, classes = _a.classes;
    return (react_1.default.createElement(Container_1.default, { disableGutters: disableGutters, fixed: fixed, maxWidth: maxWidth, classes: classes }, children));
};
exports.default = Container;
